import PropTypes from 'prop-types';
import Tooltip from '../Tooltip';

import './index.less';

export default function EventCard({ Icon, cardName, numberOfEvents, isRedIcon = false, cardDescription }) {
  return (
    <Tooltip title={cardName} description={cardDescription}>
      <div className="event-card__container">
        <Icon fill={isRedIcon ? '#d4231a' : '#1998d5'} className="event-card__icon" />
        <h3 data-testid="number-event-card"> {numberOfEvents} </h3>
        <p> {cardName}</p>
      </div>
    </Tooltip>
  );
}

EventCard.propTypes = {
  cardName: PropTypes.string.isRequired,
  cardDescription: PropTypes.string,
  numberOfEvents: PropTypes.number.isRequired,
  Icon: PropTypes.func,
  isRedIcon: PropTypes.bool,
};
